"use strict";

var _classCallCheck = require("/home/runner/work/es-product-index/es-product-index/node_modules/@babel/runtime/helpers/classCallCheck");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var feed_readers_json_1 = __importDefault(require("../../fixtures/regexes/client/feed_readers.json"));

var version_1 = require("../../utils/version");

var variable_replacement_1 = require("../../utils/variable-replacement");

var user_agent_1 = require("../../utils/user-agent");

var FeedReaderParser = function FeedReaderParser(options) {
  var _this = this;

  _classCallCheck(this, FeedReaderParser);

  this.options = {
    versionTruncation: 1
  };

  this.parse = function (userAgent) {
    var result = {
      type: "",
      name: "",
      version: "",
      url: ""
    };

    var _iterator = _createForOfIteratorHelper(feed_readers_json_1.default),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var feedReader = _step.value;
        var match = user_agent_1.userAgentParser(feedReader.regex, userAgent);
        if (!match) continue;
        result.type = "feed reader";
        result.name = variable_replacement_1.variableReplacement(feedReader.name, match);
        result.version = version_1.formatVersion(variable_replacement_1.variableReplacement(feedReader.version, match), _this.options.versionTruncation);
        result.url = feedReader.url;
        break;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return result;
  };

  this.options = Object.assign(Object.assign({}, this.options), options);
};

exports.default = FeedReaderParser;